import { Box, SxProps, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { theme } from 'theme';
import { backgroundIsLight } from './utils';

export const RailroadStatusBar: FC<{
  value: string | undefined | null;
  previousValue: string | undefined | null;
  nextValue: string | undefined | null;
  label: string | undefined | null;
  pageNumber: string;
  sx?: SxProps;
  color?: string;
}> = ({ value, previousValue, nextValue, pageNumber, color, sx, label }) => {
  const pageIsEven = Number(pageNumber || 0) % 2 === 0;

  const extendsToPreviousPage = pageIsEven && value && value === previousValue;

  return (
    <Tooltip title={label}>
      <Box
        sx={{
          height: 15,
          bgcolor: color,
          ml: extendsToPreviousPage ? '-16px' : 0,
          display: 'flex',
          alignItems: 'center',
          px: 1,
          overflow: 'hidden',
          '@media print': {
            height: 8,
          },
          ...sx,
        }}
      >
        {(value !== previousValue || value !== nextValue) && (
          <Typography
            sx={{
              width: '100%',
              fontSize: 10,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              color:
                color && backgroundIsLight(color)
                  ? theme.palette.common.black
                  : theme.palette.common.white,
              textAlign:
                value !== nextValue
                  ? value !== previousValue
                    ? 'center'
                    : 'right'
                  : undefined,
              '@media print': {
                fontSize: 4,
              },
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};
